import CommonState from '@/class/cargo/model/parameters/CommonState'
import lang from '@/lang'

/**
 * 待审核运价
 */
export const PRICE_STATE_PENDING = 0
/**
 * 已发布运价
 */
export const PRICE_STATE_EFFECTIVE = 1
/**
 *  历史运价
 */
export const PRICE_STATE_HISTORY = 2
/**
 * 新增模式
 */
export const ADD_MODE = 'addMode'
/**
 * 编辑模式
 */
export const EDIT_MODE = 'editMode'
/**
 * 全选
 */
export const SELECT_ALL = 'selectAll'
/**
 * 重置
 */
export const CLEAR_ALL = 'clearAll'
/**
 * 整箱运价查看详细
 */
export const VIEW_DETAIL = 'viewDetail'

/**
 * 整箱运价查看船期
 */
export const VIEW_SCHEDULE_DETAIL = 'viewScheduleDetail'

export const VIEW_REMARK = 'viewRemark'

export const VIEW_PODCHARGE = 'viewPODCharge'
/**
 * DataGrid的宽度或顺序发生变化
 */
export const CONFIG_CHANGED = 'configChanged'
/**
 * 重置表格
 */
export const CONFIG_RESET = 'configReset'

export const SHITT_ITEM = 'shiftItem'

/**
 * 最大结果查询数目
 */
export const MAX_QUERY_COUNT = 300

export const QUOTATION_FCL = 0

export const QUOTATION_AIR = 1

export const QUOTATION_LCL = 2

export const QUOTATION_PRE_PORT = 3

export const QUOTATION_LAST_MILE = 4

export const TACT = -4294967296.0// 2^32
export const NIL = -4294967297.0// 2^32+1
export const MINIMUN = -999999999.99// 2^32+2

export const COLOR_BLACK = 0x000000

export const COLOR_GREEN = 0x228B22

export const COLOR_RED = 0xFF0000

export const COLOR_BLUE = 0x0099FF

/**
 * 起运地类型
 * @type {string[]}
 */
export const POL_TYPE = ['rol', 'col', 'pol']

/**
 * 目的地类型
 * @type {string[]}
 */
export const POD_TYPE = ['rod', 'cod', 'pod']
/**
 * 运价订舱类型
 */
// 特价申请
export const PRICE_SOURCE_APPLY = 1
// 订舱
export const PRICE_SOURCE_BOOKING = 2
// 报价单
export const PRICE_SOURCE_QUOTATION = 3
// 询价单
export const PRICE_SOURCE_INQUIRY = 4

export const PRICE_PREPAID = new CommonState('P', '预付', 'PP')
export const PRICE_COLLECT = new CommonState('C', '到付', 'CC')
export const PRICE_BOTH = new CommonState('B', '预到付同价', 'P/C')
export const PRICE_PAYMENT_TERM = [PRICE_PREPAID, PRICE_COLLECT, PRICE_BOTH]

export const PRICE_SERVICE_MODE_NOT_REQUIRED = new CommonState('NotRequired', '不设置', 'Default')
export const PRICE_SERVICE_MODE_G4 = new CommonState('RIPI', 'WC/G4', 'WC/G4')
export const PRICE_SERVICE_MODE_MLB = new CommonState('IPI/MLB', 'IPI/MLB', 'IPI/MLB')
export const PRICE_SERVICE_MODE_AWE = new CommonState('AWE', 'AWE', 'AWE')
export const PRICE_SERVICE_MODE_RIPI = new CommonState('RIPI', 'RIPI', 'RIPI')
export const PRICE_SERVICE_MODES = [PRICE_SERVICE_MODE_NOT_REQUIRED, PRICE_SERVICE_MODE_G4, PRICE_SERVICE_MODE_MLB, PRICE_SERVICE_MODE_AWE, PRICE_SERVICE_MODE_RIPI]

export const PRICE_DIRECT_YES = new CommonState(true, '直达', 'direct')
export const PRICE_DIRECT_NO = new CommonState(false, '中转', 'transit')
export const PRICE_DIRECT = [PRICE_DIRECT_YES, PRICE_DIRECT_NO]

export const PRICE_LOCAL_CHARGE = new CommonState(0, '本地费用', 'Local Charge')
export const PRICE_DES_CHARGE = new CommonState(1, '目的地费用', 'Des Charge')
export const PRICE_SUR_CHARGE = new CommonState(2, '附加费', 'Sur charge')
export const PRICE_CHARGE_TYPE = [PRICE_LOCAL_CHARGE, PRICE_DES_CHARGE, PRICE_SUR_CHARGE]

export const WEEKS_NOTREQUIRED = new CommonState(0, '不设置', 'Default')
export const AIR_ALL = new CommonState(0, '【全部】', 'ALL')
export const ALL = new CommonState(0, '全部', 'ALL')
export const WEEKS_MON = new CommonState(1, '周一', 'MON')
export const WEEKS_TUE = new CommonState(2, '周二', 'TUE')
export const WEEKS_WED = new CommonState(3, '周三', 'WED')
export const WEEKS_THU = new CommonState(4, '周四', 'THU')
export const WEEKS_FRI = new CommonState(5, '周五', 'FRI')
export const WEEKS_SAT = new CommonState(6, '周六', 'SAT')
export const WEEKS_SUN = new CommonState(7, '周天', 'SUN')

// 运价日期类型
export const WEEKS_TYPE = [WEEKS_NOTREQUIRED, WEEKS_MON, WEEKS_TUE, WEEKS_WED, WEEKS_THU, WEEKS_FRI, WEEKS_SAT, WEEKS_SUN]
// 运价日期类型
export const DEPARTURE_DAY = [ALL, WEEKS_MON, WEEKS_TUE, WEEKS_WED, WEEKS_THU, WEEKS_FRI, WEEKS_SAT, WEEKS_SUN]

// 空运运价输入-新增方案时,航班时刻中‘全部’显示选项不统一，此处重新定义进行统一
export const AIR_DEPARTURE_DAY = [AIR_ALL, WEEKS_MON, WEEKS_TUE, WEEKS_WED, WEEKS_THU, WEEKS_FRI, WEEKS_SAT, WEEKS_SUN]

export const PREPAID = new CommonState('P', '预付', 'Prepaid')
export const COLLECT = new CommonState('C', '到付', 'Collect')
export const BOTH = new CommonState('B', '预到付同价', 'Both')

// 运价日期类型
export const PAYMENT_TERMS = [PREPAID, COLLECT, BOTH]

export const NOTREQUIRED = new CommonState(' ', '不设置', 'Default')
export const WC_G4 = new CommonState('WC/G4', 'WC/G4', 'WC/G4')
export const IPI_MLB = new CommonState('IPI/MLB', 'IPI/MLB', 'IPI/MLB')
export const AWE = new CommonState('AWE', 'AWE', 'AWE')
export const RIPI = new CommonState('RIPI', 'RIPI', 'RIPI')

// ServiceMode
export const SERVICE_MODES = [NOTREQUIRED, WC_G4, IPI_MLB, AWE, RIPI]

export const PLS_SELECT = new CommonState('', '请选择', 'PLEASE SELECT')
export const SELF = new CommonState('SELF', '自营', 'Self')
export const SHARE = new CommonState('SHARE', '共舱', 'Share')
// 舱位性质
export const CABIN_NATURE = [PLS_SELECT, SELF, SHARE]

export const SHIPOWNER_PRICE = new CommonState(1, '船东价格', 'Shipowner Price')
export const PEER_PRICE = new CommonState(2, 'NVO同行价格', 'Peer Price')
// 运价性质
export const PRICE_NATURE = [SHIPOWNER_PRICE, PEER_PRICE]

export const PRICE_STATE_COMMON = new CommonState(0, '正常', 'Common')
export const PRICE_STATE_SUSPEND = new CommonState(1, '停航', 'Suspend')
export const PRICE_STATE_REJECT = new CommonState(2, '不接', 'Reject')
export const PRICE_STATE_INQUIRY = new CommonState(3, '询价', 'Inquiry')
export const PRICE_STATE_LACK = new CommonState(4, '紧张', 'Lack')
export const PRICE_STATE_OVERBOOKED = new CommonState(5, '爆舱', 'Overbooked')
export const PRICE_STATE_SMOOTH = new CommonState(6, '畅接', 'Smooth')
export const PRICE_STATE_SINGLE_APPLY = new CommonState(7, '单票申请', 'SingleApply')

// 运价状态
export const PRICE_STATE = [PRICE_STATE_COMMON, PRICE_STATE_SUSPEND, PRICE_STATE_REJECT, PRICE_STATE_INQUIRY, PRICE_STATE_LACK, PRICE_STATE_OVERBOOKED, PRICE_STATE_SMOOTH, PRICE_STATE_SINGLE_APPLY]

// 地区类型
export const REGION = new CommonState(0, '区域', 'Region')
export const COUNTRY = new CommonState(1, '国家', 'country')
export const PORT = new CommonState(2, '港口', 'Port')

export const REGIONAL_TYPE = [REGION, COUNTRY, PORT]

// 加价类型
export const MarkupBy = new CommonState(true, '幅度加价', 'Markup By')
export const MarkupTo = new CommonState(false, '加价至', 'Markup To')

export const MARKUP_TYPE = [MarkupBy, MarkupTo]

export const SALE_STATE_NORMAL = new CommonState(0, '', '')
export const SALE_STATE_SPECIAL = new CommonState(1, '特价', 'SALE')
export const SALE_STATES = [
  SALE_STATE_NORMAL,
  SALE_STATE_SPECIAL
]

export const CLIENT_TYPE_TMP = new CommonState(0, '临时客户', 'Temporary Customer')
export const CLIENT_TYPE_FORMAL = new CommonState(1, '正式客户', 'Formal Customer')
export const CLIENT_TYPE_LIST = [
  CLIENT_TYPE_TMP,
  CLIENT_TYPE_FORMAL
]

export const CLIENT_IS_BOOKED_ALL = new CommonState(-1, '-请选择-', 'All')
export const CLIENT_IS_BOOKED_YES = new CommonState(1, '是', 'Yes')
export const CLIENT_IS_BOOKED_NO = new CommonState(0, '否', 'No')

export const CLIENT_IS_BOOKED_LIST = [
  CLIENT_IS_BOOKED_ALL,
  CLIENT_IS_BOOKED_YES,
  CLIENT_IS_BOOKED_NO
]

export const PRICE_SEAWAY_BILL_YES = new CommonState('Y', 'Y', 'Y')
export const PRICE_SEAWAY_BILL_NO = new CommonState('N', 'N', 'N')
export const PRICE_SEAWAY_BILL = [PRICE_SEAWAY_BILL_YES, PRICE_SEAWAY_BILL_NO]

// 运价状态
export const PRICE_STATE_PENDING_PRICE = new CommonState('0', '待审核', 'Under verification')
export const PRICE_STATE_CURRENT_PRICE = new CommonState('1', '已发布', 'Effective Price')
export const PRICE_STATES = [PRICE_STATE_PENDING_PRICE, PRICE_STATE_CURRENT_PRICE]

// 运价类型
export const PRICE_TYPE_TRADITIONAL = new CommonState(0, '线下运价', 'Traditional freight rates')
export const PRICE_TYPE_SPOT = new CommonState(1, '电商运价', 'spot freight rates')
export const PRICE_TYPE_ALL = new CommonState(2, '全部', 'ALL')
export const PRICE_TYPES = [PRICE_TYPE_TRADITIONAL, PRICE_TYPE_SPOT]
export const PRICE_ALL_TYPES = [PRICE_TYPE_TRADITIONAL, PRICE_TYPE_SPOT, PRICE_TYPE_ALL]

// 运价等级
export const PRICE_LEVEL_COST = new CommonState('0', 'Cost', 'Cost')
export const PRICE_LEVEL_ONE = new CommonState('1', 'Tier 1', 'Tier 1')
export const PRICE_LEVEL_TWO = new CommonState('2', 'Tier 2', 'Tier 2')
export const PRICE_LEVEL_THREE = new CommonState('99', 'Tier 3', 'Tier 3')
export const PRICE_LEVELS = [PRICE_LEVEL_COST, PRICE_LEVEL_ONE, PRICE_LEVEL_TWO, PRICE_LEVEL_THREE]

// 空运运价货物比重枚举 1:0, 1:80, 1:100, 1:120, 1:130, 1:140, 1:150, 1:167, 1:200, 1:250, 1:300, 1:350, 1:400, 1:500, 1:800, 1:1000
export const WEIGHT_VOLUME_0 = new CommonState(0, '1:0', '1:0')
export const WEIGHT_VOLUME_80 = new CommonState(80, '1:80', '1:80')
export const WEIGHT_VOLUME_100 = new CommonState(100, '1:100', '1:100')
export const WEIGHT_VOLUME_120 = new CommonState(120, '1:120', '1:120')
export const WEIGHT_VOLUME_130 = new CommonState(130, '1:130', '1:130')
export const WEIGHT_VOLUME_140 = new CommonState(140, '1:140', '1:140')
export const WEIGHT_VOLUME_150 = new CommonState(150, '1:150', '1:150')
export const WEIGHT_VOLUME_167 = new CommonState(167, '1:167', '1:167')
export const WEIGHT_VOLUME_200 = new CommonState(200, '1:200', '1:200')
export const WEIGHT_VOLUME_250 = new CommonState(250, '1:250', '1:250')
export const WEIGHT_VOLUME_300 = new CommonState(300, '1:300', '1:300')
export const WEIGHT_VOLUME_350 = new CommonState(350, '1:350', '1:350')
export const WEIGHT_VOLUME_400 = new CommonState(400, '1:400', '1:400')
export const WEIGHT_VOLUME_500 = new CommonState(500, '1:500', '1:500')
export const WEIGHT_VOLUME_800 = new CommonState(800, '1:800', '1:800')
export const WEIGHT_VOLUME_1000 = new CommonState(1000, '1:1000', '1:1000')
export const WEIGHT_VOLUMES = [
  WEIGHT_VOLUME_0,
  WEIGHT_VOLUME_80,
  WEIGHT_VOLUME_100,
  WEIGHT_VOLUME_120,
  WEIGHT_VOLUME_130,
  WEIGHT_VOLUME_140,
  WEIGHT_VOLUME_150,
  WEIGHT_VOLUME_167,
  WEIGHT_VOLUME_200,
  WEIGHT_VOLUME_250,
  WEIGHT_VOLUME_300,
  WEIGHT_VOLUME_350,
  WEIGHT_VOLUME_400,
  WEIGHT_VOLUME_500,
  WEIGHT_VOLUME_800,
  WEIGHT_VOLUME_1000
]

// 免柜期类型
export const FREE_TIME_CONSOLIDATE = new CommonState(0, 'DEM+DET合并计算', 'DEM+DET is combined')
export const FREE_TIME_RESPECTIVELY = new CommonState(1, 'DEM和DET分别计算', 'DEM and DET are calculated separately')
export const FREE_TIME_TYPE = [FREE_TIME_CONSOLIDATE, FREE_TIME_RESPECTIVELY]

// 中转类型
export const UNLIMITED = new CommonState(0, '不限', 'Unlimited')
export const DIRECT_ONLY = new CommonState(1, '仅直达', 'Direct Only')
export const TRANSIT_ONLY = new CommonState(2, '仅中转', 'Transit only')
export const TRANSIT_TO_PORT = new CommonState(3, '中转特定港口', 'Transit to specific ports')
export const DIRECT_TYPE = [UNLIMITED, DIRECT_ONLY, TRANSIT_ONLY, TRANSIT_TO_PORT]
